import {
  GET_INITIATIVE_LIST,
  GET_INITIATIVE_DETAIL,
} from '_revamp/redux/action/admin/intiative';

const initialState = {
  data: [],
  detail: {},
};

const initiative = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_INITIATIVE_LIST: {
      return {
        ...state,
        data: payload.rows,
      };
    }

    case GET_INITIATIVE_DETAIL: {
      return {
        ...state,
        detail: payload,
      };
    }

    default:
      return state;
  }
};

export default initiative;
